<template>
	<template v-if="isMultiblock == 'true'">
		<h2 v-if="factsData.config.title">{{ factsData.config.title }}</h2>
		
		<TableItemsComponent :tableData="factsData.config" :index="index" isMultiblock="true" />
	</template>

	<template v-else>
		<section :id="['container-' + index + '-' + factsData.type]" :class="['container-' + factsData.type]">
			<div class="facts-table" :class="[isMultiblock == 'false' ? 'container-xl' : '' ]">
				<div class="row">
					<div class="col-md-12">
						<h2 v-if="factsData.config.title">{{ factsData.config.title }}</h2>
						
						<TableItemsComponent :tableData="factsData.config" :index="index" isMultiblock="false" />
					</div>
				</div>
			</div>
		</section>
	</template>
</template>

<script>

import TableItemsComponent from "./TableItemsComponent.vue"

export default {
	components: {
		TableItemsComponent,
	},

	props: {
		factsData: {
			type: Object
		},
		index: {
			type: Number
		},
		isMultiblock: {
			type: String
		}
	},
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/assets/scss/design-aachen/factsComponent.scss";
</style>